import "core-js/modules/es6.string.link";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import env from "../env";
import util from "../util";
var isMqb = env.isMqb,
    isAndroid = env.isAndroid,
    isQQNews = env.isQQNews,
    isWeishi = env.isWeishi,
    isQQMusic = env.isQQMusic,
    isQQSports = env.isQQSports;
var jsapi = {
  browser: '//jsapi.qq.com/get?api=app.share,app.setShareInfo,app.getQua,app.getApkInfo',
  kb: '//mat1.gtimg.com/www/reading/android/js/jsapi/jsapi.js',
  qqmusic: '//y.gtimg.cn/music/h5/client/jsbridge.js',
  weishi: '//isee.weishi.qq.com/iseecdn/static/js/wesee-h5-share.js',
  qqsports: '//mat1.gtimg.com/sports/tua-app-sdk/master/tua-app-sdk.js'
};
var sdk = {}; // 实例

var getScript = function getScript(id, src) {
  return new Promise(function (resolve) {
    util.loadScript(id, src, resolve);
  });
};

var getType = function getType(type) {
  var map = {
    kb: window.TencentReading || window.TencentNews,
    // 快报分平台挂载对象
    qqmusic: window.M,
    weishi: window.H5_SHARE,
    qqsports: window.TencentSports
  };
  return map[type] || window[type];
};

var getSdk = function getSdk(type) {
  // 兼容用户自己导入了 script 的情况.
  var jssdk = getType(type);

  if (jssdk) {
    if (type === 'kb') window.kb = jssdk; // 快报抹平差异

    return Promise.resolve(jssdk);
  }

  return getScript(type, jsapi[type]).then(function () {
    sdk[type] = getType(type); // 快报抹平差异

    if (type === 'kb') {
      window.kb = sdk[type];
    }

    if (!sdk[type]) {
      return Promise.reject(new Error("get ".concat(type, " api error")));
    }

    return sdk[type];
  });
}; // 增加qq浏览器、qq新闻、qq音乐、微视的分享设置


var setShare = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(options) {
    var _ref2, title, desc, imgUrl, link, qqSports, browser, kb, qqmusic, Weishi, shareIns, shareInfo;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _ref2 = options || {}, title = _ref2.title, desc = _ref2.desc, imgUrl = _ref2.imgUrl, link = _ref2.link;

            if (!isQQSports) {
              _context.next = 10;
              break;
            }

            _context.next = 4;
            return getSdk('qqsports');

          case 4:
            qqSports = _context.sent;

            if (!(!qqSports || !qqSports.appSdk)) {
              _context.next = 7;
              break;
            }

            return _context.abrupt("return");

          case 7:
            qqSports.appSdk.setShare({
              title: title,
              desc: desc,
              image: imgUrl,
              url: link
            });
            _context.next = 41;
            break;

          case 10:
            if (!isMqb) {
              _context.next = 17;
              break;
            }

            _context.next = 13;
            return getSdk('browser');

          case 13:
            browser = _context.sent;

            if (browser && browser.app && browser.app.setShareInfo) {
              browser.app.setShareInfo({
                url: link,
                title: title,
                description: desc,
                img_url: imgUrl
              }, function (res) {
                console.log(res);
              });
            }

            _context.next = 41;
            break;

          case 17:
            if (!isQQNews) {
              _context.next = 25;
              break;
            }

            _context.next = 20;
            return getSdk('kb');

          case 20:
            kb = _context.sent;
            kb.setActionBtn(1);
            kb.setShareArticleInfo(title, desc, desc, link, imgUrl);
            _context.next = 41;
            break;

          case 25:
            if (!isQQMusic) {
              _context.next = 32;
              break;
            }

            _context.next = 28;
            return getSdk('qqmusic');

          case 28:
            qqmusic = _context.sent;
            qqmusic.client.invoke('ui', 'setActionBtn', {
              type: 'icon',
              content: 'share'
            }, function () {
              qqmusic.client.invoke('other', 'callShareWeb', options);
            });
            _context.next = 41;
            break;

          case 32:
            if (!isWeishi) {
              _context.next = 41;
              break;
            }

            _context.next = 35;
            return getSdk('weishi');

          case 35:
            Weishi = _context.sent;
            shareIns = new Weishi();
            shareInfo = Object.assign(options, {
              appid: '1101083114',
              sourceName: '微视',
              src_iconUrl: 'http://qzonestyle.gtimg.cn/aoi/sola/20180420174331_y8WdLUUoxL.png',
              src_action: 'plugin'
            });
            shareIns.options = {
              shareInfo: shareInfo,
              wxConfig: {
                jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareWeibo', 'onMenuShareQZone', 'showOptionMenu', 'showMenuItems', 'hideAllNonBaseMenuItem', 'showAllNonBaseMenuItem']
              },
              uiState: {
                isPreview: false,
                disableWSCustomBtn: true,
                shareConfig: {
                  qq: true,
                  qz: !isAndroid,
                  wx: true,
                  timeLine: true,
                  weibo: false
                },
                handleIconClick: null,
                title: '',
                isPreviewBase64: false,
                handlePreviewClick: null
              }
            };
            _context.next = 41;
            return shareIns.config(shareIns.options);

          case 41:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function setShare(_x) {
    return _ref.apply(this, arguments);
  };
}();

export default setShare;